import React from "react";

import Icon from "../../components/icon";
import RenderItem from "./render-item";

import * as S from "./styles";

interface MenuProps {
  itens: any[];
  isMenuOpen: boolean;
  toggleMenu?: () => void;
}

const Menu: React.FC<MenuProps> = ({ itens, isMenuOpen, toggleMenu }) => (
  <S.Container isMenuOpen={isMenuOpen}>
    <Icon
      name="menu"
      padding={10}
      cursor="pointer"
      styles={{ marginLeft: isMenuOpen && 10 }}
      onClick={toggleMenu}
      aria-label="menu"
    />

    <S.Items>
      {itens.map((el: any) => (
        <RenderItem
          item={el}
          isMenuOpen={isMenuOpen}
          key={`menu-item-${el.title}`}
        />
      ))}
    </S.Items>
  </S.Container>
);
export default Menu;
